import { InitiateSubmenuView } from '@mark43/cad-api';

export function getSelfInitiateOptions(
    initiateSubmenuView: InitiateSubmenuView,
    selfInitiateId: number
) {
    const { initiateAttributeOptions, initiateCallForServiceOptions } = initiateSubmenuView;

    const callForServiceId = initiateCallForServiceOptions.find(
        (cfs) => cfs.value === selfInitiateId
    )?.value;

    const eventOriginAttributeId = initiateAttributeOptions.find(
        (attr) => attr.value === selfInitiateId
    )?.value;

    return {
        callForServiceId,
        eventOriginAttributeId,
    };
}
